module.exports = __webpack_public_path__ + "img/order_session_icon_green.3843b3a2.svg";